import React, { useEffect, useRef } from 'react';
import { useGetApiUserContext } from '@unifyapps/network/generated/user-context-rest-api/user-context-rest-api';
import userStore from '@unifyapps/carbon/auth/userStore';

function AuthProvider({ children }: { children: React.ReactNode }) {
  const { data, isLoading } = useGetApiUserContext();
  const setCurrentUserDetails = userStore.use.actions().setCurrentUserDetails;
  const user = userStore.use.currentUserDetails();
  const isUserContextSet = useRef(!!user);

  useEffect(() => {
    if (data) {
      isUserContextSet.current = true;
      setCurrentUserDetails(data);
    }
  }, [data, setCurrentUserDetails]);

  return isUserContextSet.current && !isLoading ? <>{children}</> : null;
}

export default AuthProvider;
